import { useCallback, useMemo } from 'react';

import { Button } from '@bambi/component-library/src/components/Button/Button';
import { SimpleTooltip } from '@bambi/component-library/src/components/Tooltip/SimpleTooltip';
import { PlusIcon } from '@heroicons/react/24/outline';

import { useAppSelector } from 'src/app/store/hooks';
import { RouteTemplateIcon } from 'src/features/trip/routeTemplates/components/RouteTemplateIcon';
import { useEditRouteTemplateModal } from 'src/features/trip/routeTemplates/hooks/useEditRouteTemplateModal';

export function RouteTemplateCreateMenuItem() {
  const dispatchResponse = useAppSelector(
    (state) => state.dispatcher.dispatchResponse
  );

  const assignedTrips = useMemo(
    () => dispatchResponse?.assigned_trips ?? [],
    [dispatchResponse]
  );

  const assignments = useMemo(
    () => dispatchResponse?.assignments ?? [],
    [dispatchResponse]
  );
  const { editBulkRouteTemplateModal } = useEditRouteTemplateModal();
  const openRouteTemplateGenerator = useCallback(() => {
    editBulkRouteTemplateModal(assignments, assignedTrips);
  }, [assignedTrips, assignments, editBulkRouteTemplateModal]);

  const canCreateRouteTemplate = !!assignedTrips.length;

  return (
    <div className="flex w-full items-center">
      <SimpleTooltip
        trigger={
          <div className="flex">
            <Button
              dataTestId="dispatch-create-route-templates"
              aria-label="Create Route Template from assigned trips"
              onClick={(e) => {
                e.stopPropagation();
                openRouteTemplateGenerator();
              }}
              className="flex flex-row gap-2 !p-0 py-2 !text-xs"
              variant="ghost"
              disabled={!canCreateRouteTemplate}
            >
              <RouteTemplateIcon className="h-4 w-4" />
              Route Template from assigned trips
              <PlusIcon className="h-5 w-5" />
            </Button>
          </div>
        }
        content={!canCreateRouteTemplate ? 'No assigned trips' : null}
      />
    </div>
  );
}
